"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Google;
    }
});
var _react = /*#__PURE__*/ _interopRequireDefault(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function Google(props) {
    var svgProps = Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 21 20",
        width: "21",
        height: "20",
        fill: "none"
    }, props);
    return /*#__PURE__*/ _react.default.createElement("svg", _extends({}, svgProps), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M10.6537 4.09012C12.0634 4.08927 13.428 4.57981 14.5055 5.47483L17.5239 2.64451C16.3652 1.59249 14.9735 0.820883 13.4591 0.390911C11.9448 -0.0390604 10.3495 -0.115556 8.79991 0.167495C7.2503 0.450545 5.78903 1.08535 4.53205 2.02153C3.27507 2.95771 2.25698 4.1695 1.55859 5.56072L4.96136 8.14337C5.3582 6.96502 6.1215 5.93948 7.14313 5.21202C8.16477 4.48456 9.39295 4.09206 10.6537 4.09012Z",
        fill: "#D94F3D"
    }), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M4.65365 9.99538C4.6545 9.36495 4.75828 8.73875 4.96102 8.14076L1.55825 5.55812C0.862219 6.93688 0.5 8.45566 0.5 9.99538C0.5 11.5351 0.862219 13.0539 1.55825 14.4326L4.96102 11.85C4.75828 11.252 4.6545 10.6258 4.65365 9.99538Z",
        fill: "#F2C042"
    }), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M20.3911 8.18139H10.6992V12.2715H16.1913C15.8646 13.4279 15.116 14.425 14.0891 15.0718L17.4655 17.6349C19.6231 15.728 20.8909 12.6273 20.3911 8.18139Z",
        fill: "#5085ED"
    }), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M14.0883 15.0727C13.0448 15.6608 11.8553 15.9501 10.6537 15.908C9.39295 15.9061 8.16477 15.5136 7.14314 14.7861C6.1215 14.0586 5.3582 13.0331 4.96136 11.8548L1.55859 14.4374C2.39908 16.1057 3.69563 17.5101 5.30239 18.4924C6.90916 19.4748 8.76242 19.9962 10.6537 19.9981C13.1424 20.0646 15.5682 19.223 17.4648 17.6349L14.0883 15.0727Z",
        fill: "#57A75C"
    }));
}

//# sourceMappingURL=Google.js.map